import { render, staticRenderFns } from "./Detalhamento.vue?vue&type=template&id=203bc732&scoped=true&"
import script from "./Detalhamento.vue?vue&type=script&lang=js&"
export * from "./Detalhamento.vue?vue&type=script&lang=js&"
import style0 from "./Detalhamento.vue?vue&type=style&index=0&id=203bc732&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203bc732",
  null
  
)

export default component.exports